import { isNonNullable, isNullable, isNumber, isString, } from "../../type-guards";
export class NumberUtils {
    static toSafeNumber(value) {
        if (isNullable(value)) {
            return 0;
        }
        if (isNumber(value)) {
            return value;
        }
        if (isString(value)) {
            if (value === "") {
                return 0;
            }
            const result = parseInt(value, 10);
            if (isNaN(result)) {
                throw new Error(`not a number value is passed ${value}`);
            }
            return result;
        }
        if (typeof value === "bigint") {
            throw new Error(`typeof bigint is not treated on calculate rule yet.`);
        }
        throw new Error(`unexpected type is passed ${typeof value} [${value}]`);
    }
    static minMax(value, minMax) {
        const v1 = isNonNullable(minMax.min) ? Math.max(value, minMax.min) : value;
        const v2 = isNonNullable(minMax.max) ? Math.min(v1, minMax.max) : v1;
        return v2;
    }
    /**
     * 任意の桁で四捨五入する関数
     * @param {number} value 四捨五入する数値
     * @param {number} base どの桁で四捨五入するか（10→10の位、0.1→小数第１位）
     */
    static round(value, base) {
        const factor = 1 / base;
        return Math.round(value * factor) / factor;
    }
}
//# sourceMappingURL=number-utils.js.map